import { render, staticRenderFns } from "./DxMonitoringPests.vue?vue&type=template&id=526e4371&"
import script from "./DxMonitoringPests.vue?vue&type=script&lang=js&"
export * from "./DxMonitoringPests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports